import { createSlice } from "@reduxjs/toolkit";
import { decryptUrl, getURLParams } from "api/UrlEncryption";
const initialState = {
  urlId: {},
  reload: false,
  loading: false,
  logoUrl: "",
  urlParams: {}
};

export const urlEncryption = createSlice({
  name: "urlEncryption",
  initialState,
  reducers: {
    setUrlId: (state, action) => {
      state.urlId = {
        ...state.urlId,
        [action.payload.key]: action.payload.value,
      };
    },
    clearUrlId: (state, action) => {
      state.urlId = {};
    },
    clearUrlParams: (state, action) => {
      state.urlParams = {};
    },
    setLogoUrl: (state, action) => {
      state.logoUrl = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(decryptUrl.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(decryptUrl.fulfilled, (state, action) => {
        state.urlId = {
          ...state.urlId,
          [action.payload.key]: action.payload.value,
        };
        state.loading = false;
      })
      .addCase(decryptUrl.rejected, (state, action) => {
        state.error = "rejected";
        state.loading = false;
      });
    builder
      .addCase(getURLParams.pending, (state) => {
        state.loading = true;
      })
      .addCase(getURLParams.fulfilled, (state, action) => {
        state.urlParams = action?.payload || {};
        state.loading = false;
      })
      .addCase(getURLParams.rejected, (state) => {
        state.error = "rejected";
        state.loading = false;
      });
  },
});

export const { setUrlId, clearUrlId, setLogoUrl, clearUrlParams } = urlEncryption.actions;

export default urlEncryption.reducer;
